import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiCategory, apiGetCategories } from 'api/categories';
import { AppThunk } from 'store';

export interface CategoryState {
  id: string;
  name: string;
  color: string;
  group: string;
}

interface CategoriesState {
  categories: CategoryState[];
}

export const initialCategoriesState: CategoriesState = {
  categories: []
};

const mapCategoriesToState = (categories: ApiCategory[]): CategoryState[] => {
  if (!categories) {
    return [];
  }
  return categories.map((cat) => {
    return {
      id: cat.id,
      name: cat.attributes.name,
      color: cat.attributes.color,
      group: cat.attributes.group
    };
  });
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState: initialCategoriesState,
  reducers: {
    getCategoriesSuccess(state, action: PayloadAction<ApiCategory[]>) {
      state.categories = mapCategoriesToState(action.payload);
    },
    getCategoriesFailed(state, action: PayloadAction<string>) {
      console.log(action.payload);
    }
  }
});

export const { getCategoriesSuccess, getCategoriesFailed } =
  categoriesSlice.actions;

export default categoriesSlice.reducer;

export const fetchCategories = (): AppThunk => async (dispatch) => {
  try {
    const categories = await apiGetCategories();
    dispatch(getCategoriesSuccess(categories));
  } catch (err) {
    dispatch(getCategoriesSuccess(err.toString()));
  }
};
